import UITypography from "./ui/UITypography";
import { createStyles, makeStyles, Theme } from ".";

const NA = () => {
  const classes = useStyles();
  return (
    <UITypography variant="body2" className={classes.ctr}>
      N/A
    </UITypography>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ctr: {
      color: theme.palette.grey[200],
    },
  })
);

export default NA;
